export default __webpack_public_path__ + "images/63f52ea7f800969fde025f848638543d-activities_to_engage_with_memory_impairments.svg";